module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-1-photo-12-d1c38164ac4f0d2b0017e6f463c8085a.webp";